import React from "react";
import "./KakaoButton.css";

function KakaoButton() {
  if (window.Kakao) {
    const kakao = window.Kakao;
    if (!kakao.isInitialized()) {
      kakao.init("58b559f01cc3719c1c67347a26b3dde8");
    }

    kakao.Link.createDefaultButton({
      container: "#kakao-link-btn",
      objectType: "feed",
      content: {
        title: "견상테스트",
        description: "#견상테스트 #강아지상 #견상",
        imageUrl:
          "https://img1.daumcdn.net/thumb/R1280x0/?scode=mtistory2&fname=https%3A%2F%2Fblog.kakaocdn.net%2Fdn%2FcPO8cm%2Fbtrg8brikM4%2FK3l76Yv8VgyQotGywMBGS1%2Fimg.png",
        link: {
          mobileWebUrl: window.location.href,
          webUrl: window.location.href,
        },
      },
      //   social: {
      //     likeCount: 256,
      //     commentCount: 200,
      //     sharedCount: 333,
      //   },
      buttons: [
        {
          title: "웹으로 보기",
          link: {
            mobileWebUrl: window.location.href,
            webUrl: window.location.href,
          },
        },
      ],
    });
  }

  return (
    <div className="shareContainer">
      <div className="txt-share">견상테스트 소개하기</div>
      <button id="kakao-link-btn">
        <img
          id="img-kakao-btn"
          src="https://developers.kakao.com/assets/img/about/logos/kakaolink/kakaolink_btn_medium.png"
          alt="kakao-share-icon"
        />
      </button>
    </div>
  );
}

export default KakaoButton;
